import { removeKey } from "@prismicio/editor-support/Object"
import {
  isNestableContent,
  type NestableContent,
} from "@prismicio/types-internal/lib/content"
import type { NestableWidget } from "@prismicio/types-internal/lib/customtypes"
import { useMemo } from "react"

import { NestableWidgetSwitch } from "../NestableWidgetSwitch"

type NonRepeatableZoneContent = Readonly<Record<string, NestableContent>>

interface NonRepeatableZoneEditorProps {
  id: string
  readOnly: boolean
  nonRepeatableZone: Readonly<Record<string, NestableWidget>>
  content: NonRepeatableZoneContent
  onContentChange: (content: NonRepeatableZoneContent) => void
}

export function NonRepeatableZoneEditor(props: NonRepeatableZoneEditorProps) {
  const { content, id, nonRepeatableZone, onContentChange, readOnly } = props

  const nonRepeatableWidgets = useMemo(
    () => Object.entries(nonRepeatableZone),
    [nonRepeatableZone],
  )

  return (
    <>
      {nonRepeatableWidgets.map(
        ([nonRepeatableWidgetId, nonRepeatableWidget]) => {
          const widgetContent = content[nonRepeatableWidgetId]
          return (
            <NestableWidgetSwitch
              key={nonRepeatableWidgetId}
              id={`${id}.${nonRepeatableWidgetId}`}
              readOnly={readOnly}
              nestableWidget={nonRepeatableWidget}
              content={
                isNestableContent(widgetContent) ? widgetContent : undefined
              }
              onContentChange={(nonRepeatableWidgetContent) => {
                onContentChange(
                  updateNonRepeatableWidgetContent(
                    content,
                    nonRepeatableWidgetId,
                    nonRepeatableWidgetContent,
                  ),
                )
              }}
            />
          )
        },
      )}
    </>
  )
}

function updateNonRepeatableWidgetContent(
  nonRepeatableZoneContent: NonRepeatableZoneContent,
  nonRepeatableWidgetId: string,
  nonRepeatableWidgetContent: NestableContent | undefined,
): NonRepeatableZoneContent {
  if (!nonRepeatableWidgetContent)
    return removeKey(nonRepeatableZoneContent, nonRepeatableWidgetId)

  return {
    ...nonRepeatableZoneContent,
    [nonRepeatableWidgetId]: nonRepeatableWidgetContent,
  }
}
